import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {

  private title$ = new BehaviorSubject<string>(null);

  setTitle(title: string) {
    this.title$.next(title);
  }

  getTitle(): BehaviorSubject<string> {
    return this.title$;
  }
}
